/* RO quiz — 3 answers → scored matches. Out-of-stock products are
   excluded at the data layer; scoring only ranks what's buyable. */
(function () {
  'use strict';

  var BREW_METHODS = {
    drip: ['batch-drip', 'v60', 'chemex'],
    press: ['french-press', 'aeropress'],
    espresso: ['espresso', 'moka-pot'],
    cold: ['cold-brew']
  };
  var ROAST_BANDS = { light: [1, 2], medium: [2, 3, 4], dark: [4, 5] };
  /* Scoring uses the 1-5 integer; the shareable link uses the shopper-facing
     roast names, because that is what Search & Discovery exposes as a filter. */
  var ROAST_FILTER_NAMES = {
    light: ['Light', 'Light-medium'],
    medium: ['Light-medium', 'Medium', 'Medium-dark'],
    dark: ['Medium-dark', 'Dark']
  };
  var FLAVOR_WORDS = {
    chocolate: ['chocolate', 'cocoa', 'caramel', 'molasses', 'brown sugar', 'butterscotch', 'honey', 'toffee'],
    fruit: ['berry', 'fruit', 'citrus', 'orange', 'apple', 'raisin', 'floral', 'jasmine', 'pear', 'strawberry', 'lemon'],
    nutty: ['nut', 'hazelnut', 'almond', 'spice', 'cinnamon', 'crema', 'smooth', 'earthy', 'herbal']
  };

  function money(cents) {
    var d = cents / 100;
    return d % 1 === 0 ? '$' + d.toFixed(0) : '$' + d.toFixed(2);
  }

  function init(root) {
    var dataEl = root.querySelector('[data-quiz-data]');
    if (!dataEl) return;
    var products = JSON.parse(dataEl.textContent).filter(function (p) { return p.available; });

    var steps = root.querySelectorAll('[data-quiz-step]');
    var dots = root.querySelectorAll('[data-quiz-dot]');
    var results = root.querySelector('[data-quiz-results]');
    var grid = root.querySelector('[data-quiz-grid]');
    var allLink = root.querySelector('[data-quiz-all]');
    var backBtn = root.querySelector('[data-quiz-back]');
    var answers = [null, null, null];
    var current = 0;

    function show(step) {
      current = step;
      steps.forEach(function (s, i) {
        var active = i === step;
        s.classList.toggle('is-active', active);
        s.hidden = !active;
      });
      dots.forEach(function (d, i) {
        d.classList.toggle('is-active', i === step);
        d.classList.toggle('is-done', i < step);
      });
      results.hidden = true;
      backBtn.hidden = step === 0;
    }

    function score(p) {
      var s = 0;
      var methods = BREW_METHODS[answers[0]] || [];
      var brewHit = methods.some(function (m) { return (p.best || '').indexOf(m) !== -1; });
      /* A coffee explicitly marked for cold brew is a hard match — it must not
         then be knocked out by the roast band, or asking for cold brew can
         return everything except the cold brew. */
      var coldMatch = answers[0] === 'cold' && (p.best || '').indexOf('cold-brew') !== -1;

      /* Weighted so nothing can outrank it: a coffee ground coarse specifically
         for cold brew belongs in the results of anyone who says they cold brew,
         even when the roast and flavour terms both favour something else. */
      if (coldMatch) s += 12;
      else if (answers[0] === 'cold' && typeof p.roast === 'number' && p.roast >= 4) s += 2;
      else if (brewHit) s += 4;

      /* p.roast is null when a product carries no roast_level metafield. The
         section used to emit a fabricated 3 there, which quietly made an
         unclassified bag look like a medium and let it be recommended to
         someone who asked for dark. Now it is null and simply sits out the
         roast round: no bonus, no penalty, so it can still win on brew method
         and flavour but can never be scored on a roast nobody recorded.
         Guard with a number check — `null >= 4` is false but `null - n` is
         arithmetic on 0, which is exactly the silent wrong answer. */
      var hasRoast = typeof p.roast === 'number';
      if (!coldMatch && hasRoast) {
        var band = ROAST_BANDS[answers[1]] || [];
        if (band.indexOf(p.roast) !== -1) s += 3;
        else s -= Math.min(3, Math.abs(p.roast - band[Math.floor(band.length / 2)]));
      }

      var isFlavored = p.tags.indexOf('flavored') !== -1;
      if (answers[2] === 'flavored') {
        s += isFlavored ? 6 : -4;
      } else {
        if (isFlavored) s -= 2;
        var words = FLAVOR_WORDS[answers[2]] || [];
        var notes = (p.notes || '').toLowerCase();
        var hits = words.filter(function (w) { return notes.indexOf(w) !== -1; }).length;
        /* Weighted above the brew term so that among coffees which all suit the
           brewer, the flavour answer is what actually decides the order. */
        s += Math.min(5, hits * 2);
      }
      return s;
    }

    /* Large groups of coffees tie exactly (all 8 flavored share a roast level),
       and a stable sort would then show the same three every time. Hashing the
       handle together with the answers spreads ties evenly while staying
       deterministic, so a shared result is still reproducible. An index
       rotation was tried first and clustered badly — different answers kept
       landing on the same trio. */
    function tieRank(p) {
      var h = answers.join('|') + '#' + p.handle;
      var acc = 2166136261;
      for (var i = 0; i < h.length; i++) {
        acc ^= h.charCodeAt(i);
        acc = (acc * 16777619) >>> 0;
      }
      return acc;
    }

    function renderResults() {
      var ranked = products
        .map(function (p) { return { p: p, s: score(p), t: tieRank(p) }; })
        .sort(function (a, b) { return (b.s - a.s) || (a.t - b.t); })
        .slice(0, 3);

      grid.innerHTML = ranked.map(function (r) {
        var p = r.p;
        /* Same ladder as snippets/card-product.liquid. The old fallback labelled
           anything without an origin metafield a "Blend", which asserts an origin
           detail the product data does not carry and disagreed with that same
           product's card in the collection grid. */
        var eyebrow = p.origin;
        if (!eyebrow) {
          if (p.tags.indexOf('flavored') !== -1) eyebrow = 'Flavored';
          else if (p.tags.indexOf('blend') !== -1) eyebrow = 'Blend';
          else eyebrow = 'Coffee';
        }
        return (
          '<article class="ro-card">' +
            '<a href="' + p.url + '" class="ro-card__media-link" tabindex="-1" aria-hidden="true">' +
              '<div class="ro-card__media"><img class="ro-card__img" src="' + p.img + '" alt="" loading="lazy"></div>' +
            '</a>' +
            '<div class="ro-card__info">' +
              '<p class="ro-card__eyebrow">' + eyebrow + '</p>' +
              '<h3 class="ro-card__title"><a class="ro-card__link" href="' + p.url + '">' + p.title + '</a></h3>' +
              (p.notes ? '<p class="ro-card__notes">' + p.notes + '</p>' : '') +
              '<div class="ro-card__prices"><span class="ro-card__price">From ' + money(p.price) + '</span>' +
              (p.club ? '<span class="ro-card__club">or ' + money(p.club) + ' with the club</span>' : '') +
              '</div>' +
            '</div>' +
          '</article>'
        );
      }).join('');

      /* Storefront filters take repeated params, not comma-joined values.
         There is no product-tag filter configured, so the flavored answer
         narrows by landing on the flavored collection instead. */
      var flavoredAnswer = answers[2] === 'flavored';
      var params = new URLSearchParams();
      params.append('filter.v.availability', '1');
      /* Every flavored coffee is a medium roast, so also applying the roast
         filter on that collection yields an empty page for the light and dark
         answers. The collection is already the narrowing device. */
      if (!flavoredAnswer) {
        (ROAST_FILTER_NAMES[answers[1]] || []).forEach(function (name) {
          params.append('filter.p.m.coffee.roast_name', name);
        });
      }
      var base = flavoredAnswer ? '/collections/coffee-flavors' : '/collections/explore-our-coffee';
      allLink.href = base + '?' + params.toString();

      steps.forEach(function (s) { s.hidden = true; s.classList.remove('is-active'); });
      dots.forEach(function (d) { d.classList.add('is-done'); d.classList.remove('is-active'); });
      results.hidden = false;
      backBtn.hidden = false;

      /* The controls the visitor just used are now hidden, so move focus to the
         results heading — otherwise focus falls back to <body> and a screen
         reader announces nothing at all. */
      var heading = results.querySelector('h2');
      if (heading) {
        heading.setAttribute('tabindex', '-1');
        heading.focus({ preventScroll: true });
      }
      results.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    root.addEventListener('click', function (e) {
      var opt = e.target.closest('[data-quiz-answer]');
      if (opt) {
        answers[current] = opt.getAttribute('data-quiz-answer');
        if (current < 2) show(current + 1);
        else renderResults();
        return;
      }
      if (e.target.closest('[data-quiz-back]')) {
        if (!results.hidden) show(2);
        else if (current > 0) show(current - 1);
      }
      if (e.target.closest('[data-quiz-restart]')) {
        answers = [null, null, null];
        show(0);
      }
    });

    show(0);
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-ro-quiz]').forEach(init);
  });
})();
